import { ReactComponent as ButtonsIcon } from "./buttons.svg";
import { ReactComponent as CardsIcon } from "./cards.svg";
import { ReactComponent as ChartsIcon } from "./charts.svg";
import { ReactComponent as FormsIcon } from "./forms.svg";
import { ReactComponent as HomeIcon } from "./home.svg";
import { ReactComponent as ModalsIcon } from "./modals.svg";
import { ReactComponent as PagesIcon } from "./pages.svg";
import { ReactComponent as TablesIcon } from "./tables.svg";
import { ReactComponent as HeartIcon } from "./heart.svg";
import { ReactComponent as EditIcon } from "./edit.svg";
import { ReactComponent as TrashIcon } from "./trash.svg";
import { ReactComponent as ForbiddenIcon } from "./forbidden.svg";
import { ReactComponent as GithubIcon } from "./github.svg";
import { ReactComponent as FacebookIcon } from "./facebook.svg";
import { ReactComponent as MailIcon } from "./mail.svg";
import { ReactComponent as CartIcon } from "./cart.svg";
import { ReactComponent as ChatIcon } from "./chat.svg";
import { ReactComponent as MoneyIcon } from "./money.svg";
import { ReactComponent as PeopleIcon } from "./people.svg";
import { ReactComponent as SearchIcon } from "./search.svg";
import { ReactComponent as MoonIcon } from "./moon.svg";
import { ReactComponent as SunIcon } from "./sun.svg";
import { ReactComponent as BellIcon } from "./bell.svg";
import { ReactComponent as MenuIcon } from "./menu.svg";
import { ReactComponent as DropdownIcon } from "./dropdown.svg";
import { ReactComponent as OutlinePersonIcon } from "./outlinePerson.svg";
import { ReactComponent as OutlineCogIcon } from "./outlineCog.svg";
import { ReactComponent as OutlineLogoutIcon } from "./outlineLogout.svg";
import { ReactComponent as ProductIcon } from "./product.svg";
import { ReactComponent as OrderIcon } from "./order.svg";
import { ReactComponent as CustomerIcon } from "./customer.svg";
import { ReactComponent as BranchIcon } from "./branch.svg";
import { ReactComponent as ReceiptIcon } from "./receipt.svg";
import { ReactComponent as IssueIcon } from "./issue.svg";
import { ReactComponent as MapIcon } from "./map.svg";
import { ReactComponent as SupplierIcon } from "./supplier.svg";
import { ReactComponent as NotFoundIcon } from "./notfound.svg";
import { ReactComponent as EmployeeIcon } from "./employ.svg";
import { ReactComponent as ReportIcon } from "./report.svg";

export {
  ButtonsIcon,
  CardsIcon,
  ChartsIcon,
  FormsIcon,
  HomeIcon,
  ModalsIcon,
  PagesIcon,
  TablesIcon,
  HeartIcon,
  EditIcon,
  TrashIcon,
  ForbiddenIcon,
  GithubIcon,
  FacebookIcon,
  MailIcon,
  CartIcon,
  ChatIcon,
  MoneyIcon,
  PeopleIcon,
  SearchIcon,
  MoonIcon,
  SunIcon,
  BellIcon,
  MenuIcon,
  DropdownIcon,
  OutlinePersonIcon,
  OutlineCogIcon,
  OutlineLogoutIcon,
  ProductIcon,
  OrderIcon,
  CustomerIcon,
  BranchIcon,
  ReceiptIcon,
  IssueIcon,
  MapIcon,
  SupplierIcon,
  NotFoundIcon,
  EmployeeIcon,
  ReportIcon,
};

export const icons = [
  {
    name: "HomeIcon",
    component: HomeIcon,
  },
  {
    name: "ProductIcon",
    component: ProductIcon,
  },
  {
    name: "OrderIcon",
    component: OrderIcon,
  },
  {
    name: "CustomerIcon",
    component: CustomerIcon,
  },
  {
    name: "ButtonsIcon",
    component: ButtonsIcon,
  },
  {
    name: "CardsIcon",
    component: CardsIcon,
  },
  {
    name: "ChartsIcon",
    component: ChartsIcon,
  },
  { name: "FormsIcon", component: FormsIcon },
  { name: "ModalsIcon", component: ModalsIcon },
  { name: "PagesIcon", component: PagesIcon },
  { name: "TablesIcon", component: TablesIcon },
  { name: "HeartIcon", component: HeartIcon },
  { name: "EditIcon", component: EditIcon },
  { name: "TrashIcon", component: TrashIcon },
  { name: "ForbiddenIcon", component: ForbiddenIcon },
  { name: "GithubIcon", component: GithubIcon },
  { name: "FacebookIcon", component: FacebookIcon },
  { name: "MailIcon", component: MailIcon },
  { name: "CartIcon", component: CartIcon },
  { name: "ChatIcon", component: ChatIcon },
  { name: "MoneyIcon", component: MoneyIcon },
  { name: "PeopleIcon", component: PeopleIcon },
  { name: "SearchIcon", component: SearchIcon },
  { name: "MoonIcon", component: MoonIcon },
  { name: "SunIcon", component: SunIcon },
  { name: "BellIcon", component: BellIcon },
  { name: "MenuIcon", component: MenuIcon },
  { name: "DropdownIcon", component: DropdownIcon },
  { name: "OutlinePersonIcon", component: OutlinePersonIcon },
  { name: "OutlineCogIcon", component: OutlineCogIcon },
  { name: "OutlineLogoutIcon", component: OutlineLogoutIcon },
  { name: "BranchIcon", component: BranchIcon },
  { name: "ReceiptIcon", component: ReceiptIcon },
  { name: "IssueIcon", component: IssueIcon },
  { name: "MapIcon", component: MapIcon },
  { name: "SupplierIcon", component: SupplierIcon },
  { name: "NotFoundIcon", component: NotFoundIcon },
  { name: "EmployeeIcon", component: EmployeeIcon },
  { name: "ReportIcon", component: ReportIcon },
];

export const iconMap = {
  HomeIcon: HomeIcon,
  ProductIcon: ProductIcon,
  OrderIcon: OrderIcon,
  CustomerIcon: CustomerIcon,
  ButtonsIcon: ButtonsIcon,
  CardsIcon: CardsIcon,
  ChartsIcon: ChartsIcon,
  FormsIcon: FormsIcon,
  ModalsIcon: ModalsIcon,
  PagesIcon: PagesIcon,
  TablesIcon: TablesIcon,
  HeartIcon: HeartIcon,
  EditIcon: EditIcon,
  TrashIcon: TrashIcon,
  ForbiddenIcon: ForbiddenIcon,
  GithubIcon: GithubIcon,
  FacebookIcon: FacebookIcon,
  MailIcon: MailIcon,
  CartIcon: CartIcon,
  ChatIcon: ChatIcon,
  MoneyIcon: MoneyIcon,
  PeopleIcon: PeopleIcon,
  SearchIcon: SearchIcon,
  MoonIcon: MoonIcon,
  SunIcon: SunIcon,
  BellIcon: BellIcon,
  MenuIcon: MenuIcon,
  DropdownIcon: DropdownIcon,
  OutlinePersonIcon: OutlinePersonIcon,
  OutlineCogIcon: OutlineCogIcon,
  OutlineLogoutIcon: OutlineLogoutIcon,
  BranchIcon: BranchIcon,
  ReceiptIcon: ReceiptIcon,
  IssueIcon: IssueIcon,
  MapIcon: MapIcon,
  SupplierIcon: SupplierIcon,
  NotFoundIcon: NotFoundIcon,
  EmployeeIcon: EmployeeIcon,
  ReportIcon: ReportIcon,
};
